import { Nullable } from "@/api/ApiClient";

export type ProviderRecibeFormData = Nullable<{
    id: string,
    created: string,
    total: number,
    abono: number,
    motivo: string,
    forma_pago: string,
    exchange_rate: number,
    reference: string,
    numero_recibo: number,
    comments: string,
    bankAccountId: string,
    bankAccount: any,
    anulado: boolean,
    creditOperatorId: string,
    creditOperator: any,
    providerId: string,
    provider: any,
    currencyId: string,
    currency: any,
    providerInvoices: any[],
    user: string,
}>;

export const ProviderRecibeRelatedAttributes: Array<keyof ProviderRecibeFormData> = ["provider", "bankAccount", "currency", "creditOperator", "providerInvoices"];